import { createClient } from '@libsql/client';

const tursoUrl = import.meta.env.VITE_TURSO_DB_URL;
const tursoAuthToken = import.meta.env.VITE_TURSO_AUTH_TOKEN;

if (!tursoUrl || !tursoAuthToken) {
  console.error("Turso database URL or auth token is not defined. Check your .env.local file.");
  throw new Error("Turso configuration missing.");
}

const turso = createClient({
  url: tursoUrl,
  authToken: tursoAuthToken,
});


export const initializeDatabase = async () => {
  try {
    await turso.execute(`
      CREATE TABLE IF NOT EXISTS users (
        id INTEGER PRIMARY KEY AUTOINCREMENT,
        name TEXT NOT NULL,
        email TEXT UNIQUE NOT NULL,
        hashed_password TEXT NOT NULL,
        role TEXT CHECK(role IN ('admin', 'user')) DEFAULT 'user',
        created_at DATETIME DEFAULT CURRENT_TIMESTAMP,
        updated_at DATETIME DEFAULT CURRENT_TIMESTAMP
      )
    `);

    await turso.execute(`
      CREATE TABLE IF NOT EXISTS properties (
        id INTEGER PRIMARY KEY AUTOINCREMENT,
        title TEXT NOT NULL,
        description TEXT NOT NULL,
        price INTEGER NOT NULL,
        address TEXT NOT NULL,
        city TEXT NOT NULL,
        state TEXT NOT NULL,
        lat REAL,
        lng REAL,
        bedrooms INTEGER,
        bathrooms INTEGER,
        area INTEGER,
        parking INTEGER,
        year_built INTEGER,
        amenities TEXT,
        images TEXT,
        property_type TEXT NOT NULL,
        status TEXT DEFAULT 'available',
        featured INTEGER DEFAULT 0,
        created_at DATETIME DEFAULT CURRENT_TIMESTAMP,
        updated_at DATETIME DEFAULT CURRENT_TIMESTAMP
      )
    `);

    await turso.execute('CREATE INDEX IF NOT EXISTS idx_property_type ON properties(property_type)');
    await turso.execute('CREATE INDEX IF NOT EXISTS idx_status ON properties(status)');
    await turso.execute('CREATE INDEX IF NOT EXISTS idx_featured ON properties(featured)');
    await turso.execute('CREATE INDEX IF NOT EXISTS idx_city ON properties(city)');
    await turso.execute('CREATE INDEX IF NOT EXISTS idx_price ON properties(price)');
  } catch (error) {
    console.error('Error initializing database:', error);
    throw error;
  }
};

export const db = turso;